/** @jsx jsx */
import { Container, jsx } from 'theme-ui';

const Footer: React.FC = () => (
  <Container as={'footer'}>© 2021 Royce Townsend</Container>
);

export default Footer;
